import {
  gql, useQuery 
} from "@apollo/client"

export const CategoryFragment = gql`
    fragment CategoryFragment on CategoryTree {
        uid
        url_key
        adv(currentPage: $currentPage) {
            id
            title
            img
            link
            page
            position
        }
    }
`

export const ProductsFragment = gql`
    fragment ProductsFragment on Products {
        items {
            id
            uid
            name
            fabrics_mark
            stock_status
            version
            price_range {
                maximum_price {
                    final_price {
                        currency
                        value
                    }
                    regular_price {
                        currency
                        value
                    }
                    discount {
                        amount_off
                    }
                }
                minimum_price {
                    final_price {
                        currency
                        value
                    }
                    regular_price {
                        currency
                        value
                    }
                    discount {
                        amount_off
                    }
                }
            }
            sku
            image {
                url(type: "thumbnail", width: 320, height: 470)
            }
            hover_image(width: 320, height: 470)
            small_image {
                url(type: "thumbnail", width: 90, height: 132)
            }

            # TODO: 尺寸处理，列表色块
            show_colors(
                width: 692
                height: 1016
                category_uid: $id #TODO: 筛选的颜色label
                filter_color: $filter_color
            ) {
                items {
                    label
                    rgb
                    image
                    hover_image
                    small_image
                    small_hover_image
                    is_selected
                }
                total
            }
            product_mark
            video_url
            stock_status
            rating_summary
            review_count
            __typename
            url_key
        }
        page_info {
            total_pages
        }

        total_count
    }
`

export const GET_CATEGORY = gql`
    query GetCategories(
        $id: String!
        $pageSize: Int!
        $currentPage: Int!
        $filters: ProductAttributeFilterInput!
        $sort: ProductAttributeSortInput
        $filter_color: String
    ) {
        categories(filters: { category_uid: { in: [$id] } }) {
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            items {
                id
                uid
                ...CategoryFragment
            }
        }
        products(
            pageSize: $pageSize
            currentPage: $currentPage
            filter: $filters
            sort: $sort
        ) {
            ...ProductsFragment
        }
    }
    ${CategoryFragment}
    ${ProductsFragment}
`

export const useGetCategories = (variables) => {
  const {
    loading, error, data 
  } = useQuery(GET_CATEGORY, {
    variables,
    fetchPolicy: "network-only",
  })

  return {
    loading,
    error,
    categories: data?.categories?.items,
    products: data?.products,
  }
}

